export default __webpack_public_path__ + "static/media/axon.f5f70284.png";